<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon medium color="#fff">add</v-icon>
          </div>
          <h1 style="display: inline">Crear Nuevo Horario</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-card flat class="border-container" style="overflow: visible">
              <v-card-text>
                <div
                  class="v-input border-container pa-3 mb-3 v-input--selection-controls v-input--radio-group v-input--radio-group--row v-input--hide-details v-input--is-label-active v-input--is-dirty theme--light"
                >
                  <div class="v-input__control">
                    <div class="v-input__slot" style="height: auto">
                      <div
                        role="radiogroup"
                        class="v-input--radio-group__input"
                      >
                        <div
                          class="v-radio theme--light"
                          @click="type = 'FULL_TIME'"
                        >
                          <label
                            aria-hidden="true"
                            class="v-label theme--light"
                            style="left: 0px; right: auto; position: relative"
                          >
                            <strong
                              :class="[type == 'FULL_TIME' ? 'red--text' : '']"
                            >
                              Tiempo completo
                            </strong>
                          </label>
                        </div>
                        <div
                          class="v-radio theme--light"
                          @click="type = 'HOURS_BY_DAY'"
                        >
                          <label
                            aria-hidden="true"
                            class="v-label theme--light"
                            style="left: 0px; right: auto; position: relative"
                          >
                            <strong
                              :class="[
                                type == 'HOURS_BY_DAY' ? 'red--text' : '',
                              ]"
                            >
                              Por horas
                            </strong>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <v-tabs-items :value="type">
                  <v-tab-item value="FULL_TIME">
                    <FullTimeForm
                      ref="fullTimeForm"
                      :selected="selected"
                      @onDeleteSelected="onDeleteSelected"
                      @onSubmit="onSubmit"
                      @onCancel="onCancel"
                      @form="onForm"
                      on-cancel-alert-msg="¿Estas seguro que deseas cancelar la creación del horario? Esta acción eliminará definitivamente los datos ingresados."
                    />
                  </v-tab-item>
                  <v-tab-item value="HOURS_BY_DAY">
                    <HoursByDayForm
                      ref="hoursByDayForm"
                      :selected="selected"
                      @onDeleteSelected="onDeleteSelected"
                      @onSubmit="onSubmit"
                      @onCancel="onCancel"
                      @form="onForm"
                      @initializeScheduleDays="onInitializeScheduleDays"
                      on-cancel-alert-msg="¿Estas seguro que deseas cancelar la creación del horario? Esta acción eliminará definitivamente los datos ingresados."
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md6>
            <v-card flat class="border-container">
              <v-card-text>
                <CollaboradorsTable
                  @onSelect="onSelectCollaborators"
                  :selectedProp="selected"
                />
              </v-card-text>
            </v-card>
            <v-layout justify-end row class="py-3">
              <v-btn @click="confirmCancel" :disabled="feedback.saving"
                >Cancelar</v-btn
              >
              <v-btn
                @click="emmitSubmit"
                :disabled="feedback.saving"
                color="#ef565c"
                style="color: #fff"
              >
                Guardar
              </v-btn>
            </v-layout>
          </v-flex>

          <loading v-model="feedback.working" text="Trabajando..." />
          <success
            v-model="feedback.success"
            text="Horario creado correctamente"
          />
          <error v-model="feedback.failed" text="Error" />
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { _isSomeDifferent, _keyVal } from '../../../utils/genericUtils.js'
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import CollaboradorsTable from './CollaboratorsTable.vue'
import FullTimeForm from './FullTime.vue'
import HoursByDayForm from './HoursByDay.vue'

export default {
  components: {
    CollaboradorsTable,
    FullTimeForm,
    HoursByDayForm,
    loading,
    success,
    error,
  },
  data: () => ({
    initial_HOURS_BY_DAY_Form: {},
    isFormEdited: false,
    feedback: {
      success: false,
      failed: false,
      working: false,
      saving: false,
    },
    type: 'FULL_TIME',
    breadcrumbs: [
      {
        text: 'Horarios',
        disabled: false,
        href: '/es/panel/checker',
      },
      {
        text: 'Nuevo horario',
        disabled: true,
        href: '/es/panel/checker/create',
      },
    ],
    selected: [],
  }),
  methods: {
    onInitializeScheduleDays(form) {
      this.initial_HOURS_BY_DAY_Form = structuredClone(form)
    },
    onForm(form) {
      if (form.type === 'FULL_TIME') {
        this.isFormEdited = _isSomeDifferent(
          _keyVal(structuredClone(form)),
          _keyVal({
            collaboratorIds: [],
            type: 'FULL_TIME',
            name: '',
            startTime: '',
            endTime: '',
            minutesEarly: '',
            minutesLate: '',
          })
        )
      }
      if (form.type === 'HOURS_BY_DAY') {
        this.isFormEdited = _isSomeDifferent(
          _keyVal(structuredClone(form)),
          _keyVal(this.initial_HOURS_BY_DAY_Form)
        )
      }
    },
    confirmCancel() {
      if (this.isFormEdited === false) {
        this.onCancel()
        return
      }

      if (this.type === 'FULL_TIME') this.$refs.fullTimeForm.openCancelModal()
      else this.$refs.hoursByDayForm.openCancelModal()
    },
    emmitSubmit() {
      if (this.type === 'FULL_TIME') this.$refs.fullTimeForm.submit()
      else this.$refs.hoursByDayForm.submit()
    },
    onDeleteSelected(c) {
      this.selected = this.selected.filter((i) => c.id != i.id)
    },
    onSelectCollaborators(collaborators) {
      this.selected = collaborators
    },
    onCancel() {
      this.$router.push({
        name: 'checker',
      })
    },
    onSubmit(values) {
      this.feedback.saving = true
      this.feedback.working = true
      this.$store
        .dispatch('checker/createSchedule', values)
        .then((res) => {
          this.feedback.success = true
          setTimeout(() => {
            this.feedback.success = false
            this.$router.push({
              name: 'checker',
            })
          }, 3000)
        })
        .catch((e) => {
          this.feedback.failed = true
          this.feedback.saving = false
          setTimeout(() => {
            this.feedback.failed = false
          }, 3000)
        })
        .finally(() => (this.feedback.working = false))
    },
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
</style>
